// certificatesData.js
import img1 from '../../../image/Certificate/Spring_BD_Knitwear_Profile[1].jpg';
import img2 from '../../../image/Certificate/GOTS_Global Organic_Textile_Standard.svg';
import img3 from '../../../image/Certificate/ISO.svg';
import img4 from '../../../image/Certificate/Spring_BD_Knitwear_Profile[4].jpg';
import img5 from '../../../image/Certificate/Sedex.svg';
import img6 from '../../../image/Certificate/Higg Index.svg';
import img8 from '../../../image/Certificate/wrap.svg';
import img11 from '../../../image/Certificate/Global_Recycled_Standard.svg';
import img12 from '../../../image/Certificate/OEKOTEX_Standart_100.svg';
import img13 from '../../../image/Certificate/Spring_BD_Knitwear_Profile[13].png';
import img14 from '../../../image/Certificate/Organic_100_Standard.svg';

const images = [
  img1, img2, img3, img4, img5, img6, img8, img11, img12, img13, img14,
];

export default images;
